/* istanbul ignore file */
/** Still in development */
import React from 'react';

import { initStore, useRetrieveTranslations } from '@apps/core';

import { ENVS, get } from '@lumapps/constants';
import { AppShell } from '@lumapps/shell/components/AppShell';

import { rootReducer, transforms, keysToIgnore } from '../../ducks';
import { getBaseUrl } from '../../utils';
import { Loading } from '../Loading';
import { Pages } from '../Pages';

declare const window: any;

const Config = get();

/**
 * Main entrypoint of the login application. It takes care of setting up:
 * - initial state of the application and setting up redux and translations providers
 * - Trigger the different metrics that are needed for the application
 * - Setup the react router implementation
 */
const App = () => {
    const translationsState = useRetrieveTranslations();

    if (!translationsState) {
        return <Loading />;
    }

    const baseUrl = getBaseUrl(window.location.pathname);
    const store = initStore(rootReducer, {}, transforms, keysToIgnore);

    return (
        <AppShell
            baseUrl={baseUrl}
            store={store}
            translationsState={translationsState}
            shouldDisplayAdvancedDebugInfo={Config.environment === ENVS.DEVELOPMENT}
            shouldDisplayNotifications={false}
            errorBoundaryProps={{
                fallback: <Loading />,
            }}
            shouldDisplayCustomizations
        >
            <Pages />
        </AppShell>
    );
};

export { App };
